export const langObj = {
    "arm": "AM",
    "eng": "ENG",
    "fr": "FR",
    "arb": "SA",
    "rus": "RU"
}